import React, { useContext, useEffect, useState, useRef } from 'react';

import { bool, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { propTypes } from '../../../util/types';

import { useConfiguration } from '../../../context/configurationContext';
import { FormattedMessage, useIntl } from '../../../util/reactIntl';
import {
  Page,
} from '../../../components';

import css from './LandingPage.module.scss';

import brandImage from '../../../assets/SecuregearsBrandImage.webp';
import backgroundImage from '../../../assets/background.webp';

const PageContext = React.createContext();

const Body = ({children,className}) => {
  return (
    <div className={className+" "+css.body}>
      <div className={css.backgroundImg}><img src={backgroundImage}/></div>
      {children}
    </div>
  )
}

const LoremIpsum = () => {
  return <>
  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
  </>
}

const Button = ({children, href, type, className, onClick})  => {
  const classes = {header:css.buttonHeader,sml:css.buttonSml,large:css.buttonLarge,medium:css.buttonMedium};
  return (
    <a onClick={onClick} className={className + " " + classes[type || "header"] + " " + css.button} href={href}>{children}</a>
  )
}

const Price = ({value}) => {
  const num = (value || 1);
  return <price>${num.toFixed(2)}</price>
}

const Header = props => {
  const context = useContext(PageContext);
  const redirect = context.redirect;
  return (
    <div className={css.header}>
      <img className={css.headerbrand} src={brandImage} onClick={()=>{redirect("/")}}/>
      <div className={css.headerbuttons}>
        <Button className={css.selected} onClick={()=>{redirect("/latest-reviews")}}> sg reviews</Button>
        <Button onClick={()=>{redirect("/post-listing")}}> post listing</Button>
        <Button onClick={()=>{redirect("/login")}}> login</Button>
        <Button onClick={()=>{redirect("/signup")}}> signup</Button>
      </div>
    </div>
  );
}

import cancelIcon from '../../../assets/cancelIcon.svg';
import filterIcon from '../../../assets/filterIcon.webp';
import searchIcon from '../../../assets/searchIcon.svg';

const Icon = ({type,className}) => {
  if (type=="") return (<img/>);
  const icons = {cancel:cancelIcon,filter:filterIcon,search:searchIcon};
  
  return (<img class={className} src={icons[type]}/>);
}

const SearchBox = ({type}) => {
  const context = useContext(PageContext);
  const redirect = context.redirect;
  return (
    <div className={css.searchbox}>
      <div className={css.searchboxsubmit} onClick={()=>{redirect("/search")}}><Icon type="search"/> </div>
      <input type="text"/>
      <div className={css.searchboxstop}><Icon type="cancel"/> </div>
    </div>
  );
}

import TopbarSearchForm from '../../../containers/TopbarContainer/Topbar/TopbarSearchForm/TopbarSearchForm';


const LandingPageComp = props => {
  const config = useConfiguration();
  const intl = useIntl();
  const context = useContext(PageContext);
  const redirect = context.redirect;
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.searchPage}>
        <Header/>
        <container>
          <h2> Search your next bike </h2>
          <TopbarSearchForm appConfig={config} onSubmit={()=>{console.log("boop")}}/>
          <div className={css.verticalLinks}>
            <a onClick={()=>{redirect("/search")}}> Road Bikes </a>
            <a onClick={()=>{redirect("/search")}}> Mountain Bikes </a>
            <a onClick={()=>{redirect("/search")}}> EBikes </a>
          </div>
        </container>
      </Body>
    </Page>
  );
};
const LoginPageComp = props => {
  const config = useConfiguration();
  const intl = useIntl();
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.loginPage}>
        <Header/>
        <container>
          <input type="text" placeholder="Username"/>
          <input type="password" placeholder="Password"/>
          <a>Forgot Password?</a>
          <Button type="large">Login</Button>
        </container>
      </Body>
    </Page>
  );
};

import bikePic1 from '../../../assets/bikePic1.jpeg';
import bikePic2 from '../../../assets/bikePic2.webp';



const ListingsPageComponent = props => {
  const config = useConfiguration();
  const intl = useIntl();
  const context = useContext(PageContext);
  const redirect = context.redirect;
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.listingsPage}>
        <Header/>
        <container>
          <top>
            <left><SearchBox/></left>
            <filters>
              <div className={css.filter}><Icon type="filter"/></div>
              <div className={css.filterPicks}>
                <Button type="sml" className={css.cancelable}>Type: Mountain<Icon type="cancel"/></Button>
                <Button type="sml" className={css.cancelable}>Brand: Trek<Icon type="cancel"/></Button>
                <Button type="sml" className={css.cancelable}>Travel: 155mm<Icon type="cancel"/></Button>
                <Button type="sml">Clear Filters</Button>
              </div>
            </filters>
          </top>
          <bottom>
            <listings>
              <listing>
                <img src={bikePic1} onClick={()=>{redirect("/listings/specialize-evo-2023")}}/>
                <detailss>
                  <name>Specialize Evo 2023</name>
                  <detail>Fork Travel:<value>150mm</value></detail> 
                  <detail>Wheel Size:<value>27.5"</value></detail> 
                  <detail>Material:<value>Aluminum</value></detail> 
                  <Price value={4500}/>
                </detailss>
              </listing>
              <listing>
                <img src={bikePic2}/>
                <detailss>
                  <name>Salsa Evo 2023</name>
                  <detail>Fork Travel:<value>150mm</value></detail> 
                  <detail>Wheel Size:<value>27.5"</value></detail> 
                  <detail>Material:<value>Aluminum</value></detail> 
                  <Price value={4500}/>
                </detailss>
              </listing>
            </listings>
          </bottom>
        </container>
      </Body>
    </Page>
  );
};

const ImagesModal = ({on,images,setOn}) => {
  const [curImageInd,setCurImageInd] = useState(0);
  const ref = useRef();
  return (<div ref={ref} className={css.modalImages} style={on? {}: {display:"none"}} onClick={(event)=>{if(event.target==ref.current){setOn(false)}}}>
    <Button className={css.left} onClick={()=>{setCurImageInd(curImageInd == 0 ? images.length - 1 : curImageInd-1)}}>&lt;</Button>
    <img src={images[curImageInd]}/>
    <Button className={css.right} onClick={()=>{setCurImageInd(curImageInd + 1 == images.length ? 0 : curImageInd+1)}}>&gt;</Button>
  </div>)
}

const ProductImage = ({images}) => {
  const [curImage,setCurImage] = useState(images[0]);
  const [onModal,setOnModal] = useState(false);

  return (<div className={css.productImages}>
    
    <div>
      <ImagesModal on={onModal} images={images} setOn={setOnModal}/>
      <img src={curImage}/>
      <Button onClick={()=>{setOnModal(true)}}>View large photos({images.length})</Button>
    </div>
    <options>
      {images.map((v)=>(<img src={v} onClick={()=>{setCurImage(v)}}/>))}
    </options>
  </div>);
}

const ListingPageComponent = props => {
  const context = useContext(PageContext);
  const redirect = context.redirect;
  const config = useConfiguration();
  const intl = useIntl();
  const name = "Specialize Evo 2023";
  const price = 3333;
  const specs = [
    {name:"Front derailler",value:"Shimano Ulteggra"},
    {name:"Rear derailler",value:"Shimano Ulteggra"},
    {name:"Crank",value:"Shimano Ulteggra"},
    {name:"Breaks",value:"Shimano Ulteggra"},
    {name:"Wheels",value:"Giant SLR 1"},
    {name:"Cassette",value:"Shimano Ulteggra"},
    {name:"Pedals",value:"Not Included"},
    {name:"Frame material",value:"Carbon"},
    {name:"Shifting",value:"Mechanical"},
    {name:"Wheel Size",value:"27.5\""},
  ]
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.listingPage}>
        <Header/>
        <container>
          <breadcrumbs><value>Used Bikes</value> <value>Cross Country Bikes</value> <value>Salsa Cutthroat 2023</value></breadcrumbs>
          <top>
            <left>
              <ProductImage images={[bikePic1,bikePic2]}/>
            </left>
            <right>
              <name className={css.productName}>{name}</name> 
              <Price value={price}/>
              <seller>
                <img/>
                <div><name>John Doe</name><a>Contact</a></div>
              </seller>
              <pricing>
                <line>Order breakdown</line>
                <spacer/>
                <line>Sale price: <value><Price value={price}/></value></line>
                <line>Shipping: <value><Price value={55}/></value></line>
                <spacer/>
                <line>Total Price: <value><Price value={3388}/></value></line>
              </pricing>
              <buttons>
              <Button onClick={()=>{redirect("/delivery-options")}}>Buy Now</Button>
              <Button className={css.grayButton}>Make An Offer</Button>
              </buttons>
            </right>
          </top>
          <bottom>
            <left>
              <h3>Description</h3>
              <LoremIpsum/>
            </left>
            <right>
              <h3>Specs</h3>
              <detailsgrid>
                {specs.map((v)=>(
                  <><type>{v.name}: </type><value> {v.value}</value></>
                ))}
                
              </detailsgrid>
            </right>
          </bottom>
        </container>
      </Body>
    </Page>
  );
};

import countries from '../../../assets/countries.json';

const InputR = ({name,value,label})=>(<optionv>
  <input type="radio" name={name} id={"radio-"+value+"-"+name} value={value}/>
  <label for={"radio-"+value+"-"+name}>{label}</label>
</optionv>)
const InputD = ({name,label,placeholder})=>(<div>
  <label>{label}</label>
  <input type="text" name={name} placeholder={placeholder}/>
</div>);
const InputL = ({name,label,placeholder,options})=>(<div>
  <label>{label}</label>
  <select type="text" name={name}>
  <option value="">{placeholder}</option>
    {options.map((v)=>(<option value={v.value}>{v.label}</option>))}
  </select>
</div>);
const ShippingOptionD = ({date,source,price})=>(<>
  <date>{date || "Fri, Jul 11, 2025*"}</date>
  <type>{source.toUpperCase() || "UPS GROUND"}</type>
  <Price value={price || 224.25}/>
</>);

export const DeliveryOptionsComponent = props => {
  const config = useConfiguration();
  const intl = useIntl();
  const context = useContext(PageContext);
  const redirect = context.redirect;

  const name = "Specialize Evo 2023";

  const countriesSelection = [{value:"united states",label:"United States"},{value:"canada",label:"Canada"}]//countries.map((v)=>({value:v.name.toLowerCase(),label:v.name}));
  const shippingOptions = [
    {
      date: "Fri, Jul 11, 2025",
      source: "ups ground",
      value: "ups-ground",
      price: 224.25
    },
    {
      date: "Fri, Jul 11, 2025",
      source: "ups 2nd day air",
      value: "ups-2nd-day-air",
      price: 550.95
    },
    {
      date: "Fri, Jul 11, 2025",
      source: "ups next day air",
      value: "ups-next-day-air",
      price: 775.35
    }
  ]
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.deliveryPage}>
        <Header/>
        <container>
          <left>
            <h3> Delivery Options </h3>
            <InputR name="delivery-type" value="local-pickup" label="Local Pickup (free)"/>
            <InputR name="delivery-type" value="shiping" label="Ship (calculate)"/>
            <div className={css.shippingForm}>
              <line>Calculate Shipping</line>
              <div className={css.grid}>
                <InputD name="streetAddress" placeholder="123 Example Street" label="Street Address"/>
                <InputD name="aptnum" placeholder="A 42" label="Apt # - optional"/>
                <InputD name="postalcode" placeholder="00100" label="Postal Code"/>
                <InputD name="city" placeholder="Helsinki" label="City"/>
                <InputD name="state" placeholder="Enter your state" label="State"/>
                <InputL name="country" placeholder="Select a country..." label="Country" options={countriesSelection}/>
              </div>
              <Button type="medium">Calculate</Button>
            </div>
            <div className={css.shippingOptions}>
              <line>Select Shipping Option</line>
              {shippingOptions.map((v)=>(
                <InputR name="delivery-option" value={v.value} label={<ShippingOptionD {...v}/>}/>
              ))}
              
            </div>
          </left>
          <right>
            <img src={bikePic1}/>
            <name className={css.productName}>{name}</name> 
            <pricing>
              <line>Order breakdown</line>
              <line>Sale price: <value><Price value={3333}/></value></line>
              <line>Shipping: <value><Price value={224.25}/></value></line>
              <line>Sales Tax: <value><Price value={55}/></value></line>
              <spacer/>
              <line>Total Price: <value><Price value={3607.90}/></value></line>
            </pricing>
            <Button onClick={()=>{redirect("/")}}> Proceed to checkout</Button>
          </right>
        </container>
      </Body>
    </Page>
  );
};

import listingPic1 from '../../../assets/listingPic1.jpeg';
import listingPic2 from '../../../assets/listingPic2.jpeg';
import listingPic3 from '../../../assets/listingPic3.jpeg';
import listingPic4 from '../../../assets/listingPic4.jpeg';

export const ReviewsPageComponent = ({}) => {
  const config = useConfiguration();
  const intl = useIntl();
  
  return (
    <Page
      title={"Secure Gears"}
    >
      <Body className={css.reviewsPage + " " + css.darkenedBody}>
        <Header/>
        <container>
          <top>
            latest reviews
          </top>
          <middle>
            <grid>
              <left>
                <review>
                  <img src={listingPic1}/>
                  <info>
                    <name>Test Riding 2025 Specialized Enduro Camp</name>
                    <description>Does the latest model surpass the expectations set by its predecessor</description>
                    <authordate>Jon Doe - May 11, 2025</authordate>
                  </info>
                </review>
              </left>
              <right>
                <review>
                  <img src={listingPic2}/>
                  <info>
                    <name> New 2025 Kona HeiHei</name>
                    <authordate>Jon Doe - May 11, 2025</authordate>
                  </info>
                </review>
                <review>
                  <img src={listingPic3}/>
                  <info>
                    <name> 10 best shoes 2025</name>
                    <authordate>Jon Doe - May 11, 2025</authordate>
                  </info>
                </review>
                <review>
                  <img src={listingPic4}/>
                  <info>
                    <name> Best Bikes for Colorado Rockies</name>
                    <authordate>Jon Doe - May 11, 2025</authordate>
                  </info>
                </review>
              </right>
            </grid>
          </middle>
        </container>
      </Body>
    </Page>
  );
};

const GlobalContext = ({children}) => {
  const initialState = {

  }

  const [state, dispatch] = useReducer((state, payload) => {
    return {
      ...state,
      ...payload,
    }
  }, initialState, state => state)

  return (
    <GlobalContext.Provider value={
      {
        // Application State
        state,
        // Handlers
        dispatch,
      }}>
      {children}
    </GlobalContext.Provider>
  );
}


export const LandingPageComponent = props => {
  const [Page,setPage] = useState("/");

  const pages = {
    "/latest-reviews":<ReviewsPageComponent/>,
    "/login":<LoginPageComp/>,
    "/listings/specialize-evo-2023":<ListingPageComponent/>,
    "/delivery-options":<DeliveryOptionsComponent/>,
    "/search":<ListingsPageComponent/>,
    "/":<LandingPageComp/>
  };

  const getPage = (page)=>{
    if (pages[page]){
      return pages[page];
    }else{
      return <LandingPageComp/>;
    }
  }

  const context = {
    redirect:(page)=>{
      setPage(page);
    },

  };
  
  return <PageContext.Provider value={context}>
    {getPage(Page)}
  </PageContext.Provider>;

};
  

LandingPageComponent.propTypes = {
  pageAssetsData: object,
  inProgress: bool,
  error: propTypes.error,
};

const mapStateToProps = state => {
  const { pageAssetsData, inProgress, error } = state.hostedAssets || {};
  return { pageAssetsData, inProgress, error };
};

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const LandingPage = compose(connect(mapStateToProps))(LandingPageComponent);

export default LandingPage;
